/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import DateTimePicker from 'react-datetime';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import { Breakpoint } from 'react-socks';

class SchedulePanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            active: false,
            components: {
                date: null,
                postAfter: 3
            }
        };

        this.onUpdate = this.onUpdate.bind(this);
        this.setDate = this.setDate.bind(this);
        this.setPostSchedule = this.setPostSchedule.bind(this);
        this.initializeDate = this.initializeDate.bind(this);
        this.onToggleSchedule = this.onToggleSchedule.bind(this);
        this.createVersion = this.createVersion.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);

        this.datePicker = React.createRef();

    }

    componentDidMount() {

        if (this.props.posts.length && this.props.posts[0].params.post_ts !== 0) {
            this.initializeDate(this.props.posts[0].params.post_ts);
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.posts.length && this.props.posts[0].params.post_ts !== 0 && this.props.posts[0].params.post_ts !== prevProps.posts[0].params.post_ts) {
            this.initializeDate(this.posts[0].params.post_ts);
        }

    }

    initializeDate(unixTimestamp) {
        let date = null,
            active = this.state.active,
            components = this.state.components;

        if (unixTimestamp > 0) {
            active = true;
            date = moment(unixTimestamp * 1000);
        }

        components.date = date;

        this.setState({
            active,
            components
        });

    }

    setDate(date) {
        let components = this.state.components,
            active = this.state.active;

        if (!active) {
            active = true;
        }

        components.date = date;

        this.setState({
            active,
            components
        }, () => {
            // don't set the post schedule time until
            // we have a valid moment date object
            if (moment.isMoment(date)) {
                this.setPostSchedule();
            }
        });

    }

    setPostSchedule(date) {
        let dataEvent = {
            currentTarget: {
    	    		dataset: {
    	    			field: 'posts[0].params.post_ts'
    	    		}
    	    	},
    	    	target: {
    	    		value: 0
    	    	}
            },
            timestamp = (date) ? date : this.state.components.date;

        if (timestamp && timestamp.isValid()) {
            dataEvent.target.value = timestamp.unix();

            this.props.requestChange(dataEvent);

            if (date) {
                let components = this.state.components;
                components.date = date;
                this.setState({
                    components
                });
            }
        }

    }

    onUpdate(e) {

        // calling a local copy of FUM because the one attached to the props
        // links to the parents state: PostModalV2
        FormUtilityMixin.requestChange.apply(this, [e]);

    }

    onKeyPress(e) {

        if (e.key === 'Enter') {
            this.datePicker.current.handleClickOutside(e);
        }

    }

    onToggleSchedule(e) {

        let active = (e.currentTarget.dataset.togglestate === 'true') ? false : true,
            components = this.state.components;

        if (!active) {
            this.props.requestChange({
                currentTarget: {
    	    		dataset: {
    	    			field: 'posts[0].params.post_ts'
    	    		}
    	    	},
    	    	target: {
    	    		value: 0
    	    	}
            });
            components.date = null;
        } else {
            this.setPostSchedule(moment().add(1, 'days'));
        }

        this.setState({
            active,
            components
        });

    }

    createVersion(e) {
        let offset = parseInt(this.state.components.postAfter, 10),
            newDate = null,
            versionDate = null;

        if (e.currentTarget.dataset.offset) {
            offset = parseInt(e.currentTarget.dataset.offset, 10);
        }

        if (isNaN(offset)) {
            this.props.setScheduleError("Please use a number for the number of days");
            return;
        }

        for (let i = 0; i < this.props.posts.length; ++i) {
            if (parseInt(this.props.posts[i].offset, 10) === offset) {
                this.props.setScheduleError("Whoops, you've already got a post set up for that day.");
                return;
            }
        }

        if (this.props.posts.length >= 7) {
            this.props.setScheduleError("Sorry, we can only allow you to create 7 versions of a post.");
            return;
        }

        if (this.state.components.date !== null) {
            newDate = moment(this.state.components.date.unix() * 1000);
            this.props.createVersion(newDate.add(offset, 'days').unix(), offset);
        } else {
            newDate = moment().add(1, 'days');
            this.setPostSchedule(newDate);
            versionDate = moment(newDate.unix() * 1000);
            this.props.createVersion(versionDate.add(offset, 'days').unix(), offset);
            this.setState({
                active: true
            });
        }

    }

    render () {
        let pickerDate = null,
            dayLabel = this.state.components.postAfter === 1 ? 'day' : 'days',
            quickAdds = [1, 2, 4, 7],
            i = 0,
            powerScheduler = null,
            constants = this.props.app.config.constants,
            picker = null;

        pickerDate = this.state.components.date;

        if (pickerDate === null) {
            picker = (
                <div className="post-modal-scheduler">
                    <input name="blank" onClick={this.onToggleSchedule}/>
                </div>
            );
        } else {
            picker = (
                <DateTimePicker
                    ref={this.datePicker}
                    inputProps={{
                        onKeyPress:this.onKeyPress
                    }}
                    className="post-modal-scheduler"
                    initialValue={pickerDate}
                    onChange={this.setDate}
                    displayTimeZone={this.props.user.detail.timezone}
                    strictParsing={false} />
            );
        }

        if (this.props.isFreeUser()) {
            powerScheduler = (
                <div className="panel-section">
                    Want to re-share this post multiple times? <a href="/account/subscription/new">Upgrade to Pro today!</a>
                </div>
            );
        } else if (this.props.context === 'new') {
            powerScheduler = (
                <div>
                    <div className="panel-header secondary">
                        <span className="schedule-panel-label">Post another version of this content after</span>
                        <UncontrolledTextInput type="text" className="text-input scheduled-days" value={this.state.components.postAfter} onChange={this.onUpdate} data-field="components.postAfter" /> <span className="schedule-panel-label">{dayLabel}</span>
                        <button className="btn-secondary add-scheduled-post" onClick={this.createVersion}>Add</button>
                    </div>
                    <div className="panel-section quick-add-wrapper">
                        <span className="schedule-panel-label">Quick Add:</span>
                        {quickAdds.map((quickie) => {
                            return (
                                <button key={quickie} className="btn-secondary quick-add" data-offset={quickie} onClick={this.createVersion}>
                                    +{quickie + " " + ((quickie === 1) ? 'day' : 'days')}
                                </button>
                            );
                        })}
                    </div>
                </div>
            );
        }

        return (
            <div className="panel-content">
                <div className="panel-header">
                    <ToggleControl
                        active={this.state.active}
                        activeLabel="Schedule Post"
                        inactiveLabel="Schedule Post?"
                        labelPlacement="left"
                        callback={this.onToggleSchedule}
                        toggleClass="inline" />
                    <div className="panel-picker">
                        <Breakpoint desktop only>
                            {picker}
                        </Breakpoint>
                    </div>
                </div>
                <Breakpoint mobile only>
                    {picker}
                </Breakpoint>
                {powerScheduler}
                <div className="panel-section twitter-warning">
                    <a href="https://support.dlvrit.com/hc/en-us/articles/360002116333" target="_blank"><em>Due to Twitter's new policies, scheduling multiple times is not supported for Twitter.</em></a>
                </div>
            </div>
        );
    }
}

SchedulePanel.displayName = "SchedulePanel";

SchedulePanel.propTypes = {
    panels: PropTypes.object,
    post: PropTypes.object,
    requestChange: PropTypes.func,
    activateAccessory: PropTypes.func
};

SchedulePanel.defaultProps = {
    panels: {},
    post: {},
    requestChange: null,
    activateAccessory: null
};

export default SchedulePanel;
